var $ = require('jquery');
require('../lib/truncate');

var self = {};

self.initialise = function () {
  $('.panel-item p, .truncate').succinct({
    size: 200,
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/limitxt.js